import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Sparkles } from "lucide-react";
import { Input } from "../ui/input";
import { aiApi } from "./aiApi";

const MODES = [["off", "Mati"], ["director", "Pengarah Seni"], ["svg", "Reka SVG"]];
const HINT = {
  off: "Claude tidak digunakan.",
  director: "Claude tulis brief reka bentuk terperinci, kemudian pembekal gambar di atas (Gemini/OpenAI/Model AI) melukis.",
  svg: "Claude mereka bentuk terus dalam vektor (SVG → PNG). Teks BM tepat, gaya grafik rata. Pembekal di atas tidak digunakan.",
};

export default function AIClaudeImageSettings({ img, setImg, claudeKey, setClaudeKey }) {
  const [models, setModels] = useState([]);
  const [busy, setBusy] = useState(false);
  const loadModels = async () => {
    setBusy(true);
    try {
      const d = await aiApi.claudeModels(claudeKey);
      setModels(d.models || []);
      toast.success(`${d.models?.length || 0} model Claude dimuat`);
    } catch (e) { toast.error(e.response?.data?.detail || "Gagal memuat model Claude"); } finally { setBusy(false); }
  };
  const list = models.some((m) => m.id === img.claude_model) || !img.claude_model ? models : [{ id: img.claude_model, name: img.claude_model }, ...models];
  return (
    <div className="grid gap-1.5 rounded-xl border border-orange-100 bg-orange-50/50 p-2" data-testid="ai-image-claude-box">
      <div className="flex flex-wrap items-center gap-1.5">
        <span className="text-[11px] font-bold text-slate-500 w-20 flex items-center gap-1"><Sparkles className="h-3 w-3 text-orange-500" />Claude AI</span>
        {MODES.map(([v, l]) => (
          <button key={v} type="button" onClick={() => setImg({ claude_mode: v })} data-testid={`ai-image-claude-mode-${v}`}
            className={`h-8 px-3 rounded-full text-xs font-semibold border ${(img.claude_mode || "off") === v ? "bg-orange-500 border-orange-500 text-white" : "bg-white border-slate-200 text-slate-600"}`}>{l}</button>
        ))}
      </div>
      <div className="text-[10.5px] text-slate-500" data-testid="ai-image-claude-hint">{HINT[img.claude_mode || "off"]}</div>
      <div className="flex items-center gap-1.5">
        <Input type="password" value={claudeKey} onChange={(e) => setClaudeKey(e.target.value)} placeholder={img.claude_key_masked || "Kunci API Anthropic (sk-ant-...)"} className="h-9 text-xs" data-testid="ai-image-claude-key" />
        {img.claude_key_masked && <button type="button" onClick={() => setImg({ clear_claude_key: true, claude_key_masked: "", claude_mode: "off" })} className="text-[10.5px] text-rose-500 font-semibold whitespace-nowrap" data-testid="ai-image-claude-clear">Padam kunci</button>}
      </div>
      <div className="flex items-center gap-1.5">
        {list.length > 0 ? (
          <select value={img.claude_model || ""} onChange={(e) => setImg({ claude_model: e.target.value })} className="h-9 flex-1 rounded-md border border-slate-200 bg-white px-2 text-xs" data-testid="ai-image-claude-model-select">
            {list.map((m) => <option key={m.id} value={m.id} label={`${m.name} (${m.id})`} />)}
          </select>
        ) : (
          <Input value={img.claude_model || ""} onChange={(e) => setImg({ claude_model: e.target.value })} placeholder="Model Claude (cth claude-sonnet-4-5)" className="h-9 text-xs flex-1" data-testid="ai-image-claude-model-input" />
        )}
        <button type="button" onClick={loadModels} disabled={busy || (!claudeKey && !img.claude_key_masked)} className="h-9 px-3 rounded-full text-xs font-semibold border border-slate-200 bg-white text-slate-700 disabled:opacity-50 flex items-center gap-1" data-testid="ai-image-claude-load-models">
          {busy && <Loader2 className="h-3.5 w-3.5 animate-spin" />}Muat model
        </button>
      </div>
      <div className="text-[10.5px] text-slate-400">Kunci disimpan di server sahaja. Tekan "Muat model" untuk pilih model Claude (Sonnet, Opus, Haiku), kemudian Simpan.</div>
    </div>
  );
}
